export default {
  loading: false,
  listLoading: false,
  records: [],
  total: 0,
  FilteredCount: 0,
  createLoading: false,
  record: {},
  /** Booking list state for Slot Master right panel */
  bookingListLoading: false,
  bookingRecords: [],
  bookingTotal: 0,
  bookingFilteredCount: 0,
  bookingCounts: {}
}
